import React, { useState } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
  Chip
} from '@mui/material';

export default function VendorEmailTable({ vendorMetrics }) {
  const [orderBy, setOrderBy] = useState('sent');
  const [order, setOrder] = useState('desc');

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const sortedData = [...vendorMetrics].sort((a, b) => {
    if (order === 'asc') {
      return a[orderBy] < b[orderBy] ? -1 : 1;
    }
    return a[orderBy] > b[orderBy] ? -1 : 1;
  });

  const getOpenRate = (opened, sent) => {
    if (sent === 0) return 0;
    return ((opened / sent) * 100).toFixed(1);
  };

  const getOpenRateColor = (rate) => {
    const numRate = parseFloat(rate);
    if (numRate >= 70) return 'success';
    if (numRate >= 40) return 'warning';
    return 'error';
  };

  return (
    <Box padding={2}>
      <Typography variant="h6" gutterBottom>
        Vendor Email Performance
      </Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Vendor Name</TableCell>
              <TableCell align="right">
                <TableSortLabel
                  active={orderBy === 'certificates'}
                  direction={orderBy === 'certificates' ? order : 'asc'}
                  onClick={() => handleSort('certificates')}
                >
                  Certificates
                </TableSortLabel>
              </TableCell>
              <TableCell align="right">
                <TableSortLabel
                  active={orderBy === 'sent'}
                  direction={orderBy === 'sent' ? order : 'asc'}
                  onClick={() => handleSort('sent')}
                >
                  Emails Sent
                </TableSortLabel>
              </TableCell>
              <TableCell align="right">
                <TableSortLabel
                  active={orderBy === 'opened'}
                  direction={orderBy === 'opened' ? order : 'asc'}
                  onClick={() => handleSort('opened')}
                >
                  Emails Opened
                </TableSortLabel>
              </TableCell>
              <TableCell align="right">Open Rate</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Typography variant="body2" color="textSecondary">
                    No email data available
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              sortedData.map((vendor) => {
                const openRate = getOpenRate(vendor.opened, vendor.sent);
                return (
                  <TableRow key={vendor.vendorId} hover>
                    <TableCell>{vendor.vendorName}</TableCell>
                    <TableCell align="right">{vendor.certificates}</TableCell>
                    <TableCell align="right">{vendor.sent}</TableCell>
                    <TableCell align="right">{vendor.opened}</TableCell>
                    <TableCell align="right">
                      <Chip
                        label={`${openRate}%`}
                        color={getOpenRateColor(openRate)}
                        size="small"
                        variant="outlined"
                      />
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}